module.exports = __webpack_public_path__ + "img/Metal038_1K_Metalness.b6449b25.jpg";